import React from 'react';

import LoanPaymentHistoryRow from './LoanPaymentHistoryRow';

import '../assets/styles/loan/LoanPaymentHistory.scss';
import configData from '../config';

const LoanPaymentHistory = ({ data, updatePaymentHistory }) => {
  if (!data) {
    return null;
  }

  const isBnpl = configData.getTenant() === 'lightrx';

  return (
    <div className={`loanPaymentHistory ${isBnpl && 'lightrx'}`}>
      <div>
        <div>
          <div className="loanPaymentHistoryTitle">Payment History</div>
        </div>
        <div className="loanPaymentHistoryList">
          {data.map((item, index) => {
            let isLastPending = false;
            if (!!data[index + 1]?.datePaid && !item.datePaid) {
              isLastPending = true;
            }
            return (
              <LoanPaymentHistoryRow
                isLastPending={isLastPending}
                key={index}
                data={item}
                updatePaymentHistory={updatePaymentHistory}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LoanPaymentHistory;
